import React from 'react';

import { UsuarioAniversarioLista } from 'Component/Usuario';
import { VinculoEmpregaticioAniversarioLista } from 'Component/VinculoEmpregaticio';
import { useRecuperarUsuariosQuery } from 'Service';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const Aniversarios = (): React.ReactElement => {
  const {
    data: { usuarios: aniversariantesDoDia } = {},
    isFetching: buscandoDia,
  } = useRecuperarUsuariosQuery({
    finder: 'aniversariantesDoDia',
  });
  const {
    data: { usuarios: aniversariantesDoMes } = {},
    isFetching: buscandoMes,
  } = useRecuperarUsuariosQuery({
    finder: 'aniversariantesDoMes',
  });
  const {
    data: { vinculos: aniversariantesDeEmpresaDoDia } = {},
    isFetching: buscandoEmpresaDia,
  } = useRecuperarVinculosEmpregaticiosQuery({
    contain: ['Usuarios'],
    finder: 'aniversariantesDoDia',
  });
  const {
    data: { vinculos: aniversariantesDeEmpresaDoMes } = {},
    isFetching: buscandoEmpresaMes,
  } = useRecuperarVinculosEmpregaticiosQuery({
    contain: ['Usuarios'],
    finder: 'aniversariantesDoMes',
  });

  return (
    <div className="bg-white rounded shadow-sm">
      <div className="bg-primary text-white rounded-top py-2 px-3 fs-4">
        Aniversariantes
      </div>
      <div className="hf-500 overflow-auto">
        <div className="bg-light text-dark py-2 px-3 fs-5">Hoje</div>
        {aniversariantesDoDia?.map((usuario) => (
          <UsuarioAniversarioLista
            key={`${usuario.id}-${usuario.modificado}`}
            dados={usuario}
          />
        ))}
        {aniversariantesDeEmpresaDoDia?.map((usuario) => (
          <VinculoEmpregaticioAniversarioLista
            key={`${usuario.id}-${usuario.modificado}`}
            dados={usuario}
          />
        ))}
        {!buscandoDia &&
        !buscandoEmpresaDia &&
        aniversariantesDoDia?.length == 0 &&
        aniversariantesDeEmpresaDoDia?.length == 0 ? (
          <p className="text-center fs-5 mt-3">
            Não existe aniversariantes na data de hoje
          </p>
        ) : null}
        <div className="bg-light text-dark py-2 px-3 fs-5">No mês atual</div>
        {aniversariantesDoMes?.map((usuario) => (
          <UsuarioAniversarioLista
            key={`${usuario.id}-${usuario.modificado}`}
            dados={usuario}
          />
        ))}
        {aniversariantesDeEmpresaDoMes?.map((usuario) => (
          <VinculoEmpregaticioAniversarioLista
            key={`${usuario.id}-${usuario.modificado}`}
            dados={usuario}
          />
        ))}
        {!buscandoMes &&
        !buscandoEmpresaMes &&
        aniversariantesDoMes?.length == 0 &&
        aniversariantesDeEmpresaDoMes?.length == 0 ? (
          <p className="text-center fs-5 mt-3">
            Não existe aniversariantes no mês
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default Aniversarios;
